import { InjectionToken } from '@angular/core';

export enum ToastMessageType {
  success,
  error,
  info,
  warning
}

export type ToastMessage = string | string[];

export interface IToastService {
  openToast(
    message: ToastMessage,
    title: string,
    toastMessageType: ToastMessageType,
    timeOut: number
  ): void;

  openErrorToast(message: ToastMessage, title?: string): void;

  openSuccessToast(message: ToastMessage, title?: string): void;

  openWarningToast(message: ToastMessage, title?: string): void;

  openInfoToast(message: ToastMessage, title?: string): void;
}

export const TOAST_SERVICE = new InjectionToken<IToastService>('ToastService');
